(function () {
  'use strict';

  var sidebarHtmlCache = Object.create(null);
  var productJsonCache = Object.create(null);
  var imageRatioCache = Object.create(null);

  function getTemplateIcon(id) {
    var tpl = document.getElementById(id);
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return '';
    return tpl.content.firstElementChild.outerHTML;
  }

  function getCartIcon() {
    return getTemplateIcon('th-lookbook-cart-icon');
  }

  function getSuccessIcon() {
    return getTemplateIcon('th-lookbook-success-icon');
  }

  function setButtonIcon(btn, type) {
    var html = type === 'success' ? getSuccessIcon() : getCartIcon();
    if (html) btn.innerHTML = html;
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatPrice(text) {
    var t = String(text || '').trim();
    if (!t) return '';
    if (/Ft|€|\$|HUF/i.test(t)) return t;
    var num = parseFloat(t.replace(/\s/g, '').replace(',', '.'));
    if (isNaN(num)) return t;
    return new Intl.NumberFormat('hu-HU', {
      style: 'currency',
      currency: 'HUF',
      maximumFractionDigits: 0
    }).format(num);
  }

  function getGridImageForModal(modal) {
    var imgId = getModalImageId(modal);
    if (!imgId) return null;
    return (
      qs('#zooomyimage__tags-' + imgId + ' .zooomyimg') ||
      qs('#zooomyimage__tags-' + imgId + ' img') ||
      qs('.zooomyimg-' + imgId)
    );
  }

  function cacheImageRatioFromImg(img, imgId) {
    if (!img || !imgId || !img.naturalWidth || !img.naturalHeight) return null;
    var ratio = img.naturalWidth / img.naturalHeight;
    imageRatioCache[imgId] = ratio;
    applyGridImageAspectRatio(img, ratio);
    return ratio;
  }

  function applyGridImageAspectRatio(img, ratio) {
    if (!img || !ratio) return;
    img.style.aspectRatio = String(ratio);
  }

  var gridFixTimer = null;
  var gridLayoutBound = false;
  var gridFixPollCount = 0;
  var destroyedMasonryGrids = Object.create(null);

  function getMasonryInstance(grid) {
    if (!grid) return null;
    if (window.jQuery) {
      var viaJq = window.jQuery(grid).data('masonry');
      if (viaJq && typeof viaJq.layout === 'function') return viaJq;
    }
    if (window.Masonry && typeof window.Masonry.data === 'function') {
      var viaMasonry = window.Masonry.data(grid);
      if (viaMasonry && typeof viaMasonry.layout === 'function') return viaMasonry;
    }
    return null;
  }

  function detectLookbookColumnCount(container) {
    if (window.matchMedia('(max-width: 767px)').matches) return 1;

    var item = qs('.ZooomyImgColl, .ZooomyLookbookModal__item', container);
    if (!item) return 2;

    var inlineWidth = ((item.getAttribute('style') || '') + ' ' + (item.style.width || '')).match(
      /width:\s*([0-9.]+)%/i
    );
    if (inlineWidth) {
      var pct = parseFloat(inlineWidth[1]);
      if (pct > 0 && pct < 100) return Math.max(1, Math.round(100 / pct));
    }

    return 2;
  }

  function stripLookbookItemLayoutStyles(item) {
    if (!item) return;
    [
      'float',
      'position',
      'left',
      'top',
      'right',
      'bottom',
      'transform',
      'webkitTransform',
      'height',
      'width',
      'maxWidth'
    ].forEach(function (prop) {
      item.style.removeProperty(prop);
    });
  }

  function findLookbookGridContainers(root) {
    var containers = [];
    var seen = Object.create(null);

    qsa('[id^="ZooomyLookbookModal__MasonryGrid-"]', root).forEach(function (grid) {
      if (!seen[grid.id]) {
        seen[grid.id] = true;
        containers.push(grid);
      }
    });

    qsa('[id^="ZooomyLookbook-"]', root).forEach(function (wrap) {
      if (!qs('.ZooomyImgColl, .ZooomyLookbookModal__item', wrap)) return;
      if (qs('[id^="ZooomyLookbookModal__MasonryGrid-"]', wrap)) return;
      if (!seen[wrap.id]) {
        seen[wrap.id] = true;
        containers.push(wrap);
      }
    });

    return containers;
  }

  function destroyLookbookMasonry(container) {
    if (!container || !container.id || destroyedMasonryGrids[container.id]) return;
    var masonry = getMasonryInstance(container);
    if (!masonry) return;
    try {
      if (typeof masonry.destroy === 'function') masonry.destroy();
    } catch (e) {}
    destroyedMasonryGrids[container.id] = true;
  }

  function applyLookbookColumnGrid(root) {
    findLookbookGridContainers(root).forEach(function (container) {
      destroyLookbookMasonry(container);

      var cols = detectLookbookColumnCount(container);
      container.classList.add('th-lookbook-grid--columns');
      container.dataset.thLookbookCols = String(cols);
      container.style.setProperty('height', 'auto', 'important');
      container.style.setProperty('max-height', 'none', 'important');

      qsa('.ZooomyImgColl, .ZooomyLookbookModal__item', container).forEach(
        stripLookbookItemLayoutStyles
      );
    });
  }

  function scheduleLookbookGridFix(root) {
    if (gridFixTimer) window.clearTimeout(gridFixTimer);
    gridFixTimer = window.setTimeout(function () {
      gridFixTimer = null;
      applyLookbookColumnGrid(root || document);
    }, 120);
  }

  function lookbookGridLooksStable() {
    var grids = findLookbookGridContainers(document);
    if (!grids.length) return false;
    return grids.every(function (grid) {
      return !!qs('.zooomyimg, .ZooomyImgColl img', grid);
    });
  }

  function pollLookbookGridFix() {
    applyLookbookColumnGrid(document);
    gridFixPollCount += 1;
    if (lookbookGridLooksStable() && gridFixPollCount >= 2) return;
    if (gridFixPollCount < 8) {
      window.setTimeout(pollLookbookGridFix, 500);
    }
  }

  function primeGridImageLayout(img) {
    if (!img || img.dataset.thGridLayoutBound === '1') return;
    img.dataset.thGridLayoutBound = '1';

    var anchor = img.closest('[id^="zooomyimage__tags-"]');
    var imgId = anchor && anchor.id ? anchor.id.replace(/^zooomyimage__tags-/, '') : '';
    if (imgId && imageRatioCache[imgId]) {
      applyGridImageAspectRatio(img, imageRatioCache[imgId]);
    }

    function onImgReady() {
      if (imgId) cacheImageRatioFromImg(img, imgId);
      scheduleLookbookGridFix(img.closest('[id^="ZooomyLookbook-"]') || document);
    }

    if (img.complete && img.naturalWidth) {
      onImgReady();
    } else {
      img.addEventListener('load', onImgReady, { once: true });
      img.addEventListener('error', onImgReady, { once: true });
    }
  }

  function bindLookbookGridImages(root) {
    qsa(
      '[id^="ZooomyLookbook-"] .zooomyimg, [id^="ZooomyLookbook-"] .ZooomyImgColl img',
      root
    ).forEach(primeGridImageLayout);
  }

  function bindLookbookGridLayout() {
    if (gridLayoutBound) return;
    gridLayoutBound = true;

    bindLookbookGridImages(document);
    pollLookbookGridFix();

    window.addEventListener('load', function () {
      scheduleLookbookGridFix();
      window.setTimeout(scheduleLookbookGridFix, 600);
    });

    window.addEventListener(
      'resize',
      function () {
        scheduleLookbookGridFix();
      },
      { passive: true }
    );
  }

  function getImageRatio(modal) {
    var imgId = getModalImageId(modal);
    if (imgId && imageRatioCache[imgId]) return imageRatioCache[imgId];

    var modalImg = qs('.zooomygallerymodal-body img', modal);
    var ratio = cacheImageRatioFromImg(modalImg, imgId);
    if (ratio) return ratio;

    var gridImg = getGridImageForModal(modal);
    ratio = cacheImageRatioFromImg(gridImg, imgId);
    if (ratio) return ratio;

    return null;
  }

  function prewarmImageRatio(modal) {
    var ratio = getImageRatio(modal);
    if (ratio) return ratio;

    var imgId = getModalImageId(modal);
    var src =
      (qs('.zooomygallerymodal-body img', modal) || getGridImageForModal(modal) || {})
        .src;
    if (!src || !imgId) return null;

    var loader = new Image();
    loader.onload = function () {
      cacheImageRatioFromImg(loader, imgId);
      if (
        modal &&
        (modal.classList.contains('in') || modal.classList.contains('th-lookbook-modal--open'))
      ) {
        applyModalOrientation(modal, imageRatioCache[imgId]);
      }
    };
    loader.src = src;
    return null;
  }

  function cacheGridImageRatios(root) {
    qsa('[id^="zooomyimage__tags-"] .zooomyimg, [id^="zooomyimage__tags-"] img', root).forEach(
      function (img) {
        var anchor = img.closest('[id^="zooomyimage__tags-"]');
        if (!anchor || !anchor.id) return;
        var imgId = anchor.id.replace(/^zooomyimage__tags-/, '');
        cacheImageRatioFromImg(img, imgId);
        primeGridImageLayout(img);
        if (!img.complete) {
          img.addEventListener(
            'load',
            function () {
              cacheImageRatioFromImg(img, imgId);
            },
            { once: true }
          );
        }
      }
    );
  }

  function getModalFromTrigger(trigger) {
    var target = trigger.getAttribute('data-target');
    if (!target) return null;
    return qs(target);
  }

  function updateHeaderOffset() {
    var header =
      qs('.shopify-section-group-header-group') ||
      qs('header') ||
      qs('x-header') ||
      qs('.header');
    var offset = 132;
    if (header) {
      var height =
        header.offsetHeight ||
        Math.ceil(header.getBoundingClientRect().height) ||
        120;
      offset = Math.ceil(height + 12);
    }
    document.documentElement.style.setProperty('--th-lookbook-header-h', offset + 'px');
    return offset;
  }

  function cacheHeaderHeight() {
    return updateHeaderOffset();
  }

  function ensureModalPortal(modal) {
    if (!modal || modal.parentNode === document.body) return;
    document.body.appendChild(modal);
  }

  function lockPageScroll() {
    if (document.body.classList.contains('th-lookbook-locked')) return;

    var scrollbar = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--th-lookbook-scrollbar-w',
      Math.max(0, scrollbar) + 'px'
    );
    document.body.dataset.thLookbookScrollY = String(
      window.scrollY || window.pageYOffset || 0
    );
    document.documentElement.classList.add('th-lookbook-locked');
    document.body.classList.add('th-lookbook-locked');
    document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    document.body.style.setProperty('overflow', 'hidden', 'important');
  }

  function unlockPageScroll() {
    if (!document.body.classList.contains('th-lookbook-locked')) return;

    var scrollY = Number(document.body.dataset.thLookbookScrollY || 0);
    document.documentElement.classList.remove('th-lookbook-locked');
    document.body.classList.remove('th-lookbook-locked');
    document.documentElement.style.removeProperty('--th-lookbook-scrollbar-w');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    delete document.body.dataset.thLookbookScrollY;
    window.scrollTo(0, scrollY);
  }

  function resetModalShellStyles(modal) {
    if (!modal) return;

    modal.style.setProperty('position', 'fixed', 'important');
    modal.style.setProperty('inset', '0', 'important');
    modal.style.setProperty('top', '0', 'important');
    modal.style.setProperty('left', '0', 'important');
    modal.style.setProperty('right', '0', 'important');
    modal.style.setProperty('bottom', '0', 'important');
    modal.style.setProperty('width', '100%', 'important');
    modal.style.setProperty('height', '100dvh', 'important');
    modal.style.setProperty('margin', '0', 'important');
    modal.style.setProperty('padding-left', '0', 'important');
    modal.style.setProperty('padding-right', '0', 'important');
    modal.style.removeProperty('paddingLeft');
    modal.style.removeProperty('paddingRight');
    modal.style.removeProperty('marginTop');
    modal.style.removeProperty('marginLeft');

    var dialog = qs('.zooomygallerymodal-dialog', modal);
    if (!dialog) return;

    dialog.style.setProperty('position', 'relative', 'important');
    dialog.style.setProperty('margin', '0 auto', 'important');
    dialog.style.setProperty('left', 'auto', 'important');
    dialog.style.setProperty('right', 'auto', 'important');
    dialog.style.setProperty('top', 'auto', 'important');
    dialog.style.setProperty('float', 'none', 'important');
    dialog.style.setProperty('transform', 'none', 'important');
    if (
      !dialog.classList.contains('th-lookbook-dialog--portrait') &&
      !dialog.classList.contains('th-lookbook-dialog--landscape')
    ) {
      var isMobileShell = window.matchMedia('(max-width: 900px)').matches;
      var shellHeightCalc = isMobileShell
        ? 'calc(100dvh - var(--th-lookbook-header-h, 132px))'
        : 'calc(100dvh - var(--th-lookbook-header-h, 132px) - 48px)';
      dialog.style.setProperty('max-height', shellHeightCalc, 'important');
      dialog.style.setProperty('height', shellHeightCalc, 'important');
    }
    dialog.style.removeProperty('paddingLeft');
    dialog.style.removeProperty('paddingRight');
  }

  function resetSidebarForOpen(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar) return;

    var imgId = getModalImageId(modal);
    sidebar.dataset.thBuilt = '';
    sidebar.classList.remove(
      'th-lookbook-products',
      'th-lookbook-products--legacy',
      'th-lookbook-products--loading'
    );

    if (!imgId || !sidebarHtmlCache[imgId]) return;

    var hotspotCount = getHotspotTags(modal).length;
    var cachedProductCount = (sidebarHtmlCache[imgId].match(/class="th-lookbook-product"/g) || [])
      .length;

    if (!cachedProductCount || (hotspotCount && cachedProductCount < hotspotCount)) {
      delete sidebarHtmlCache[imgId];
    }
  }

  function configureModalScroll(modal) {
    var dialog = qs('.zooomygallerymodal-dialog', modal);
    var content = qs('.zooomygallerymodal-content', modal);
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!dialog || !content || !sidebar) return;

    dialog.style.setProperty('min-height', '0', 'important');
    content.style.setProperty('min-height', '0', 'important');
    content.style.setProperty('max-height', '100%', 'important');
    sidebar.style.setProperty('overflow-y', 'auto', 'important');
    sidebar.style.setProperty('overflow-x', 'hidden', 'important');
    sidebar.style.setProperty('min-height', '0', 'important');
    sidebar.style.setProperty('max-height', '100%', 'important');
    sidebar.style.setProperty('overscroll-behavior', 'contain', 'important');
    sidebar.style.setProperty('-webkit-overflow-scrolling', 'touch');
  }

  function getContainRenderBox(img, container) {
    var cw = container.clientWidth;
    var ch = container.clientHeight;
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!cw || !ch || !nw || !nh) return null;

    var scale = Math.min(cw / nw, ch / nh);
    var width = nw * scale;
    var height = nh * scale;
    return {
      left: Math.round((cw - width) / 2),
      top: Math.round((ch - height) / 2),
      width: Math.round(width),
      height: Math.round(height)
    };
  }

  function syncHotspotLayerFrame(modal) {
    var body = qs('.zooomygallerymodal-body', modal);
    var layer = body && qs('.th-lookbook-hotspot-layer', body);
    if (!body || !layer) return false;

    layer.style.removeProperty('inset');
    layer.style.left = '0';
    layer.style.top = '0';
    layer.style.width = '100%';
    layer.style.height = '100%';
    layer.style.right = 'auto';
    layer.style.bottom = 'auto';
    return true;
  }

  function parseTagPosition(tag) {
    if (!tag) return null;

    var style = tag.getAttribute('style') || '';
    var lm = style.match(/left\s*:\s*([^;]+)/i);
    var tm = style.match(/top\s*:\s*([^;]+)/i);
    var left = (lm && lm[1].trim()) || tag.style.left;
    var top = (tm && tm[1].trim()) || tag.style.top;

    if (!left && !top) return null;
    return {
      left: left || '50%',
      top: top || '50%'
    };
  }

  function getModalImageId(modal) {
    var body = qs('.zooomygallerymodal-body', modal);
    if (!body || !body.id) return null;
    return body.id.replace(/^zooomygallerymodal-/, '');
  }

  function tagsHaveProducts(tags) {
    return tags.some(function (tag) {
      return qs('.zooomytagptitle', tag);
    });
  }

  function getHotspotTags(modal) {
    var imgId = getModalImageId(modal);
    if (imgId) {
      var gridTags = qsa(
        '[id^="ZooomyLookbook-"] #zooomyimage__tags-' + imgId + ' .theimgtags'
      );
      if (gridTags.length) return gridTags;
    }
    return qsa('.zooomygallerymodal-body .theimgtags', modal);
  }

  function getProductTags(modal) {
    var modalTags = qsa('.zooomygallerymodal-body .theimgtags', modal);
    if (tagsHaveProducts(modalTags)) return modalTags;

    var imgId = getModalImageId(modal);
    if (imgId) {
      var gridTags = qsa(
        '[id^="ZooomyLookbook-"] #zooomyimage__tags-' + imgId + ' .theimgtags'
      );
      if (tagsHaveProducts(gridTags)) return gridTags;
      if (modalTags.length) return modalTags;
      if (gridTags.length) return gridTags;
    }

    return modalTags;
  }

  function sidebarHasProducts(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar) return false;
    return !!(
      qs('.th-lookbook-product', sidebar) ||
      qs('.zooomyaddtocart', sidebar) ||
      qs('a[href*="/products/"]', sidebar)
    );
  }

  function sidebarHasLegacyProducts(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar) return false;
    if (sidebar.querySelector('.th-lookbook-loading')) return false;
    return !!(
      qs('.zooomyaddtocart', sidebar) ||
      qs('a[href*="/products/"]', sidebar) ||
      (sidebar.children.length > 0 && !sidebar.classList.contains('th-lookbook-products'))
    );
  }

  function tryLegacySidebar(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar) return false;

    if (sidebar.querySelector('.th-lookbook-loading')) {
      sidebar.classList.remove(
        'th-lookbook-products',
        'th-lookbook-products--legacy',
        'th-lookbook-products--loading'
      );
      sidebar.dataset.thBuilt = '';
    }

    if (sidebar.classList.contains('th-lookbook-products') && sidebarHasProducts(modal)) {
      sidebar.dataset.thBuilt = '1';
      return true;
    }

    if (!sidebarHasLegacyProducts(modal)) return false;

    enhanceLegacySidebar(modal);
    sidebar.classList.add('th-lookbook-products', 'th-lookbook-products--legacy');
    sidebar.classList.remove('th-lookbook-products--loading');
    sidebar.dataset.thBuilt = '1';
    return sidebarHasProducts(modal);
  }

  function showSidebarLoading(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar || sidebar.dataset.thBuilt === '1') return;
    if (sidebar.querySelector('.th-lookbook-loading')) return;
    if (sidebarHasLegacyProducts(modal)) return;
    if (sidebar.querySelector('.th-lookbook-product')) return;
    if (sidebar.children.length > 0) return;

    sidebar.innerHTML =
      '<div class="th-lookbook-loading" aria-hidden="true">' +
      '<div class="th-lookbook-loading__row"></div>'.repeat(4) +
      '</div>';
    sidebar.classList.add('th-lookbook-products--loading');
  }

  function preloadModalImage(modal) {
    cacheGridImageRatios();
    prewarmImageRatio(modal);

    var img = qs('.zooomygallerymodal-body img', modal);
    var imgId = getModalImageId(modal);
    cacheImageRatioFromImg(img, imgId);
    cacheImageRatioFromImg(getGridImageForModal(modal), imgId);

    if (!img || !img.src) return;
    if (img.complete) return;
    var preloader = new Image();
    preloader.onload = function () {
      cacheImageRatioFromImg(preloader, imgId);
    };
    preloader.src = img.src;
  }

  function primeModalImage(modal) {
    var img = qs('.zooomygallerymodal-body img', modal);
    if (!img) return;
    img.loading = 'eager';
    img.decoding = 'async';
    if ('fetchPriority' in img) img.fetchPriority = 'high';
  }

  function bindSidebarDelegation(modal) {
    if (modal.dataset.thSidebarDelegation === '1') return;
    modal.dataset.thSidebarDelegation = '1';

    modal.addEventListener('click', function (e) {
      var cartBtn = e.target.closest('.th-lookbook-product__cart');
      if (!cartBtn || cartBtn.disabled || cartBtn.classList.contains('is-unavailable')) return;
      e.preventDefault();
      e.stopPropagation();

      var article = cartBtn.closest('.th-lookbook-product');
      if (!article) return;

      var variantSelect = qs('.th-lookbook-product__variant', article);
      if (variantSelect && variantSelect.value) {
        var selectedOption = variantSelect.selectedOptions[0];
        if (!selectedOption || selectedOption.getAttribute('data-available') === 'false') return;
        addToCartViaTheme(variantSelect.value, cartBtn);
        return;
      }

      var tags = getProductTags(modal);
      var tag = tags[Number(article.dataset.tagIndex)];
      if (tag) addToCart(tag, cartBtn, article);
    });
  }

  function prewarmSidebarCache() {
    qsa('.zooomygallerymodal').forEach(function (modal) {
      var imgId = getModalImageId(modal);
      if (!imgId || sidebarHtmlCache[imgId]) return;
      buildSidebar(modal, true);
    });
  }

  function collectHotspotData(modal) {
    var body = qs('.zooomygallerymodal-body', modal);
    var items = [];
    var seen = {};

    function addItem(tag, index) {
      var pos = parseTagPosition(tag);
      if (!pos) return;
      var key = pos.left + '|' + pos.top;
      if (seen[key]) return;
      seen[key] = true;
      items.push({ left: pos.left, top: pos.top, index: index });
    }

    var tags = getHotspotTags(modal);
    tags.forEach(function (tag, index) {
      addItem(tag, index);
    });

    if (!items.length && body && body.id) {
      qsa('.theimgtags', modal).forEach(function (tag, index) {
        addItem(tag, index);
      });
    }

    qsa('.th-lookbook-product[data-tag-left]', modal).forEach(function (product) {
      var left = product.dataset.tagLeft;
      var top = product.dataset.tagTop;
      if (!left && !top) return;
      var key = left + '|' + top;
      if (seen[key]) return;
      seen[key] = true;
      items.push({
        left: left,
        top: top,
        index: Number(product.dataset.tagIndex || items.length)
      });
    });

    return items;
  }

  function renderHotspotLayer(modal) {
    var body = qs('.zooomygallerymodal-body', modal);
    if (!body) return;

    var items = collectHotspotData(modal);
    if (!items.length) return;

    var anchor = qs('.ZooomyImgCollAnchor', body) || body;

    var layer = qs('.th-lookbook-hotspot-layer', body);
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'th-lookbook-hotspot-layer';
      anchor.appendChild(layer);
    } else {
      layer.innerHTML = '';
    }

    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);

    items.forEach(function (item) {
      var dot = document.createElement('span');
      dot.className = 'th-lookbook-hotspot';
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      dot.style.left = item.left;
      dot.style.top = item.top;
      dot.setAttribute('aria-label', 'Termék');
      dot.dataset.tagIndex = String(item.index);

      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        qsa('.th-lookbook-hotspot', layer).forEach(function (el) {
          el.classList.remove('is-active');
        });
        dot.classList.add('is-active');
        if (!sidebar) return;
        var product = sidebar.querySelector(
          '.th-lookbook-product[data-tag-index="' + item.index + '"]'
        );
        if (product) {
          qsa('.th-lookbook-product', sidebar).forEach(function (el) {
            el.classList.remove('is-active');
          });
          product.classList.add('is-active');
          product.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });

      layer.appendChild(dot);
    });

    requestAnimationFrame(function () {
      refreshHotspotLayout(modal);
    });
  }

  function clearModalOrientation(modal) {
    var dialog = qs('.zooomygallerymodal-dialog', modal);
    if (!dialog) return;
    dialog.classList.remove('th-lookbook-dialog--landscape', 'th-lookbook-dialog--portrait');
    dialog.style.removeProperty('--th-lookbook-modal-max-w');
    dialog.style.removeProperty('--th-lookbook-image-share');
    dialog.style.removeProperty('--th-lookbook-sidebar-share');
    dialog.style.removeProperty('height');
    dialog.style.removeProperty('max-height');
  }

  function applyMobileModalBodyHeight(modal, ratio) {
    var body = qs('.zooomygallerymodal-body', modal);
    var dialog = qs('.zooomygallerymodal-dialog', modal);
    if (!body || !ratio) return;

    // Teljes képernyős dialog magasság mobilon (nincs desktop -48px)
    if (dialog) {
      var fullH = 'calc(100dvh - var(--th-lookbook-header-h, 132px))';
      dialog.style.setProperty('height', fullH, 'important');
      dialog.style.setProperty('max-height', fullH, 'important');
    }

    var availableWidth =
      dialog && dialog.clientWidth > 0
        ? dialog.clientWidth
        : Math.max(0, window.innerWidth);

    var idealHeight = Math.round(availableWidth / ratio);
    var maxHeight = Math.min(Math.round(window.innerHeight * 0.55), 420);
    var targetHeight = Math.min(idealHeight, maxHeight);

    body.style.setProperty('flex', '0 0 ' + targetHeight + 'px', 'important');
    body.style.setProperty('height', targetHeight + 'px', 'important');
    body.style.setProperty('max-height', targetHeight + 'px', 'important');
  }

  function applyModalOrientation(modal, ratioOverride) {
    var dialog = qs('.zooomygallerymodal-dialog', modal);
    var img = qs('.zooomygallerymodal-body img', modal);
    if (!dialog) return;

    var imgId = getModalImageId(modal);
    var ratio = ratioOverride || getImageRatio(modal);
    if (!ratio && img && img.naturalWidth && img.naturalHeight) {
      ratio = img.naturalWidth / img.naturalHeight;
      cacheImageRatioFromImg(img, imgId);
    }

    if (window.matchMedia('(max-width: 900px)').matches) {
      if (ratio) applyMobileModalBodyHeight(modal, ratio);
      return;
    }

    dialog.classList.remove('th-lookbook-dialog--landscape', 'th-lookbook-dialog--portrait');

    if (!ratio) {
      dialog.classList.add('th-lookbook-dialog--portrait');
      dialog.style.removeProperty('--th-lookbook-modal-max-w');
      dialog.style.removeProperty('--th-lookbook-image-share');
      dialog.style.removeProperty('--th-lookbook-sidebar-share');
      return;
    }

    if (ratio < 1.08) {
      dialog.classList.add('th-lookbook-dialog--portrait');

      var portraitHeight = window.innerHeight - updateHeaderOffset() - 48;
      var sidebarTarget = Math.min(400, Math.max(320, Math.round(window.innerWidth * 0.28)));
      var idealImageWidth = Math.round(portraitHeight * ratio);
      var idealDialogWidth = idealImageWidth + sidebarTarget;
      var maxDialog = window.innerWidth - 48;

      if (idealDialogWidth > maxDialog) {
        idealDialogWidth = maxDialog;
        idealImageWidth = Math.max(220, idealDialogWidth - sidebarTarget);
        portraitHeight = Math.round(idealImageWidth / ratio);
      }

      var portraitImageShare = (idealImageWidth / idealDialogWidth) * 100;

      dialog.style.setProperty('--th-lookbook-modal-max-w', idealDialogWidth + 'px');
      dialog.style.setProperty('--th-lookbook-image-share', portraitImageShare.toFixed(2) + '%');
      dialog.style.setProperty(
        '--th-lookbook-sidebar-share',
        (100 - portraitImageShare).toFixed(2) + '%'
      );
      dialog.style.setProperty('height', portraitHeight + 'px', 'important');
      dialog.style.setProperty('max-height', portraitHeight + 'px', 'important');
      return;
    }

    dialog.style.setProperty(
      'height',
      'calc(100dvh - var(--th-lookbook-header-h, 132px) - 48px)',
      'important'
    );
    dialog.style.setProperty(
      'max-height',
      'calc(100dvh - var(--th-lookbook-header-h, 132px) - 48px)',
      'important'
    );

    dialog.classList.add('th-lookbook-dialog--landscape');

    var contentHeight = dialog.clientHeight;
    if (!contentHeight || contentHeight > window.innerHeight) {
      contentHeight = window.innerHeight - updateHeaderOffset() - 48;
    }

    var sidebarTarget = Math.min(420, Math.max(320, Math.round(window.innerWidth * 0.26)));
    var idealImageWidth = contentHeight * ratio;
    var idealDialogWidth = Math.round(idealImageWidth + sidebarTarget);
    var maxDialog = Math.min(window.innerWidth - 32, 1720);
    var minDialog = Math.min(window.innerWidth - 32, 1180);
    idealDialogWidth = Math.max(minDialog, Math.min(maxDialog, idealDialogWidth));

    var imageShare = ((idealDialogWidth - sidebarTarget) / idealDialogWidth) * 100;
    imageShare = Math.max(66, Math.min(78, imageShare));

    dialog.style.setProperty('--th-lookbook-modal-max-w', idealDialogWidth + 'px');
    dialog.style.setProperty('--th-lookbook-image-share', imageShare.toFixed(2) + '%');
    dialog.style.setProperty(
      '--th-lookbook-sidebar-share',
      (100 - imageShare).toFixed(2) + '%'
    );
  }

  function refreshHotspotLayout(modal) {
    applyModalOrientation(modal);
    syncHotspotLayerFrame(modal);
  }

  function bindHotspotResize(modal) {
    if (modal.dataset.thHotspotResizeBound === '1') return;
    modal.dataset.thHotspotResizeBound = '1';

    var body = qs('.zooomygallerymodal-body', modal);
    var img = body && qs('img', body);
    if (!body || !img || typeof ResizeObserver === 'undefined') return;

    var observer = new ResizeObserver(function () {
      if (!modal.classList.contains('th-lookbook-modal--open') && !modal.classList.contains('in')) {
        return;
      }
      refreshHotspotLayout(modal);
    });
    observer.observe(body);
    observer.observe(img);
    modal.dataset.thHotspotObserver = '1';
  }

  var headerGuardObserver = null;

  function ensureHeaderVisible() {
    qsa(
      '.shopify-section-group-header-group, header, nav, .site-header, .header, x-header'
    ).forEach(function (el) {
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
    });
  }

  function startHeaderGuardObserver() {
    if (headerGuardObserver) return;

    var targets = qsa(
      '.shopify-section-group-header-group, header, nav, .site-header, x-header'
    );
    if (!targets.length) return;

    headerGuardObserver = new MutationObserver(function () {
      ensureHeaderVisible();
    });

    targets.forEach(function (el) {
      headerGuardObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
    });
  }

  function stopHeaderGuardObserver() {
    if (headerGuardObserver) {
      headerGuardObserver.disconnect();
      headerGuardObserver = null;
    }
  }

  function protectHeaderFromZooomy() {
    if (!window.jQuery || window.jQuery.fn._thZooomyHeaderPatch) return;

    var origHide = window.jQuery.fn.hide;
    window.jQuery.fn.hide = function () {
      var filtered = this.filter(function () {
        if (!this.closest) return true;
        if (this.closest('.shopify-section-group-header-group')) return false;
        var tag = (this.tagName || '').toLowerCase();
        if (tag === 'header' || tag === 'nav') return false;
        if (this.classList && (
          this.classList.contains('site-header') ||
          this.classList.contains('header')
        )) return false;
        return true;
      });
      return origHide.apply(filtered, arguments);
    };
    window.jQuery.fn._thZooomyHeaderPatch = true;
  }

  function injectHotspotOverrides() {
    if (qs('#th-lookbook-zooomy-override')) return;
    var style = document.createElement('style');
    style.id = 'th-lookbook-zooomy-override';
    style.textContent =
      '.zooomygallerymodal .theimgtags,.zooomygallerymodal .zooomytagspot{display:block!important;visibility:visible!important;opacity:1!important}';
    document.head.appendChild(style);
  }

  function renderHotspotsWhenReady(modal) {
    applyModalOrientation(modal, getImageRatio(modal));
    renderHotspotLayer(modal);

    var img = qs('.zooomygallerymodal-body img', modal);
    if (!img) return;

    function finish() {
      var imgId = getModalImageId(modal);
      var before = getImageRatio(modal);
      cacheImageRatioFromImg(img, imgId);
      var after = getImageRatio(modal);
      if (after && after !== before) applyModalOrientation(modal, after);
      renderHotspotLayer(modal);
    }

    if (img.complete) {
      finish();
      return;
    }

    img.addEventListener('load', finish, { once: true });
  }

  function syncHotspots(modal) {
    injectHotspotOverrides();
    qsa('.theimgtags', modal).forEach(function (tag) {
      tag.style.setProperty('display', 'block', 'important');
      tag.style.setProperty('visibility', 'visible', 'important');

      var spot = qs('.zooomytagspot', tag);
      if (spot) {
        spot.style.setProperty('display', 'block', 'important');
        spot.style.setProperty('visibility', 'visible', 'important');
        spot.style.setProperty('opacity', '1', 'important');
      }
    });
    renderHotspotsWhenReady(modal);
  }

  function centerModal(modal) {
    if (!modal) return;

    ensureHeaderVisible();
    resetModalShellStyles(modal);

    modal.style.setProperty('display', 'flex', 'important');
    modal.style.setProperty('align-items', 'center', 'important');
    modal.style.setProperty('justify-content', 'center', 'important');
    modal.style.setProperty('z-index', 'var(--th-lookbook-modal-z, 10050)', 'important');

    applyModalOrientation(modal, getImageRatio(modal));
  }

  function enhanceLegacySidebar(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar || sidebar.classList.contains('th-lookbook-products')) return;

    var tags = getProductTags(modal);
    qsa('a', sidebar).forEach(function (link) {
      link.style.textDecoration = 'none';
      link.style.background = 'none';
      link.style.backgroundImage = 'none';
    });

    qsa('.zooomyaddtocart', sidebar).forEach(function (btn, index) {
      btn.classList.add('th-lookbook-product__cart');
      btn.setAttribute('aria-label', 'Kosárba');
      btn.textContent = '';
      setButtonIcon(btn, 'cart');
      var tag = tags[index];
      if (!tag) return;
      if (btn.dataset.thCartBound === '1') return;
      btn.dataset.thCartBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled || btn.classList.contains('is-unavailable') || btn.classList.contains('zsoldout')) {
          return;
        }
        addToCart(tag, btn);
      });
      applyCartButtonAvailability(btn, !btn.classList.contains('zsoldout'));
    });
  }

  function applyCartButtonAvailability(btn, available) {
    if (!btn) return;
    if (available) {
      btn.classList.remove('is-unavailable');
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    } else {
      btn.classList.add('is-unavailable');
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    }
  }

  function isTagAvailable(tag, variantSelect) {
    if (variantSelect && variantSelect.selectedOptions[0]) {
      return variantSelect.selectedOptions[0].getAttribute('data-available') !== 'false';
    }

    var panel = qs('.zooomy___show___tags', tag);
    if (!panel) return true;

    if (qs('.zooomyaddtocart.zsoldout', panel)) return false;

    var select = qs('.zooomyshopvariant', panel);
    if (!select) return true;

    var options = qsa('option', select);
    if (!options.length) return true;

    if (options.length === 1) {
      return options[0].getAttribute('data-available') !== 'false';
    }

    var selected = select.selectedOptions[0] || options[0];
    if (selected) return selected.getAttribute('data-available') !== 'false';

    return options.some(function (option) {
      return option.getAttribute('data-available') !== 'false';
    });
  }

  function bindVariantAvailability(sidebar) {
    qsa('.th-lookbook-product__variant', sidebar).forEach(function (select) {
      if (select.dataset.thVariantBound === '1') return;
      select.dataset.thVariantBound = '1';

      select.addEventListener('change', function () {
        var article = select.closest('.th-lookbook-product');
        var cartBtn = article && qs('.th-lookbook-product__cart', article);
        var option = select.selectedOptions[0];
        applyCartButtonAvailability(
          cartBtn,
          !!(option && option.getAttribute('data-available') !== 'false')
        );
      });
    });
  }

  function syncSidebarCartAvailability(sidebar, tags) {
    qsa('.th-lookbook-product', sidebar).forEach(function (article) {
      var index = Number(article.dataset.tagIndex);
      var tag = tags[index];
      var cartBtn = qs('.th-lookbook-product__cart', article);
      var variantSelect = qs('.th-lookbook-product__variant', article);
      applyCartButtonAvailability(cartBtn, tag ? isTagAvailable(tag, variantSelect) : true);
    });
    bindVariantAvailability(sidebar);
  }

  function isValidVariantId(id) {
    return !!(id && /^\d+$/.test(String(id).trim()));
  }

  function getProductHandleFromTag(tag, href) {
    if (tag && tag.id) {
      var match = tag.id.match(/theimgtags-\d+-(.+)$/);
      if (match && match[1]) return decodeURIComponent(match[1]);
    }

    var sourceHref = href;
    if (!sourceHref && tag) {
      var panel = qs('.zooomy___show___tags', tag);
      var link = panel && qs('a[href*="/products/"]', panel);
      sourceHref = link ? link.getAttribute('href') : '';
    }

    if (sourceHref) {
      var hrefMatch = sourceHref.match(/\/products\/([^/?#]+)/);
      if (hrefMatch && hrefMatch[1]) return decodeURIComponent(hrefMatch[1]);
    }

    return null;
  }

  function getVariantIdFromSelect(select) {
    if (!select) return null;

    if (isValidVariantId(select.value)) return String(select.value).trim();

    var options = qsa('option', select);
    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      if (!isValidVariantId(option.value)) continue;
      if (option.getAttribute('data-available') === 'false') continue;
      return String(option.value).trim();
    }

    for (var j = 0; j < options.length; j++) {
      if (isValidVariantId(options[j].value)) return String(options[j].value).trim();
    }

    return null;
  }

  function getVariantId(tag) {
    var panel = qs('.zooomy___show___tags', tag);
    if (!panel) return null;

    return getVariantIdFromSelect(qs('.zooomyshopvariant', panel));
  }

  function buildVariantSelectHtml(select, index) {
    if (!select) return '';

    var options = qsa('option', select).filter(function (option) {
      var label = option.textContent.trim();
      return label && label !== 'Default Title';
    });

    if (options.length <= 1) return '';

    var html =
      '<select class="th-lookbook-product__variant" data-tag-index="' +
      index +
      '" aria-label="Válassz variánst">';

    options.forEach(function (option) {
      var available = option.getAttribute('data-available');
      html +=
        '<option value="' +
        option.value +
        '"' +
        (available ? ' data-available="' + available + '"' : '') +
        (option.selected ? ' selected' : '') +
        '>' +
        option.textContent.trim() +
        '</option>';
    });

    html += '</select>';
    return html;
  }

  function fetchFirstAvailableVariantId(handle) {
    if (!handle) return Promise.resolve(null);
    if (productJsonCache[handle]) return Promise.resolve(productJsonCache[handle]);

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed');
        return res.json();
      })
      .then(function (product) {
        var variants = product.variants || [];
        var variant = variants.find(function (item) {
          return item.available;
        });
        var id = variant ? String(variant.id) : null;
        if (id) productJsonCache[handle] = id;
        return id;
      })
      .catch(function () {
        return null;
      });
  }

  function markCartButtonState(btn, state) {
    if (!btn) return;
    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.classList.remove('is-added');
      setButtonIcon(btn, 'cart');
      return;
    }
    if (state === 'success') {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setButtonIcon(btn, 'success');
      setTimeout(function () {
        btn.classList.remove('is-added');
        setButtonIcon(btn, 'cart');
      }, 1800);
      return;
    }
    btn.classList.remove('is-loading', 'is-added');
    setButtonIcon(btn, 'cart');
  }

  function addToCartViaTheme(variantId, btn) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var sectionsToBundle = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    formData.append('sections', sectionsToBundle.join(','));
    formData.append('sections_url', root + 'variants/' + variantId);

    markCartButtonState(btn, 'loading');
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', { bubbles: true })
    );

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:end', { bubbles: true })
        );

        if (!result.ok) {
          throw result.json;
        }

        if (
          window.themeVariables &&
          window.themeVariables.settings &&
          (window.themeVariables.settings.cartType === 'page' ||
            window.themeVariables.settings.pageType === 'cart')
        ) {
          window.location.href = root + 'cart';
          return null;
        }

        return fetch(root + 'cart.js', { credentials: 'same-origin' })
          .then(function (res) {
            return res.json();
          })
          .then(function (cartContent) {
            cartContent.sections = result.json.sections;
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart: cartContent,
                  onSuccessDo: 'force_open_drawer'
                }
              })
            );
            return result.json;
          });
      })
      .then(function () {
        markCartButtonState(btn, 'success');
      })
      .catch(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:end', { bubbles: true })
        );
        markCartButtonState(btn);
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      });
  }

  function addToCart(tag, btn, article) {
    if (btn.disabled || btn.classList.contains('is-unavailable')) return;
    if (!isTagAvailable(tag, article && qs('.th-lookbook-product__variant', article))) return;

    var variantId = getVariantId(tag);
    if (variantId) {
      addToCartViaTheme(variantId, btn);
      return;
    }

    var handle =
      (article && article.dataset.productHandle) || getProductHandleFromTag(tag);
    if (!handle) return;

    markCartButtonState(btn, 'loading');
    fetchFirstAvailableVariantId(handle).then(function (id) {
      if (!id) {
        markCartButtonState(btn);
        return;
      }
      addToCartViaTheme(id, btn);
    });
  }

  function mountCloseButton(modal) {
    var closeBtn = qs('.zooomygallerybtn-close', modal);
    var content = qs('.zooomygallerymodal-content', modal);
    if (!closeBtn || !content || closeBtn.dataset.thMoved === '1') return;
    content.appendChild(closeBtn);
    closeBtn.dataset.thMoved = '1';
  }

  function buildSidebar(modal, prewarmOnly) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar) return false;

    var imgId = getModalImageId(modal);

    if (imgId && sidebarHtmlCache[imgId] && !prewarmOnly) {
      var cachedTags = getProductTags(modal);
      var cachedReadyCount = cachedTags.filter(function (tag) {
        return getVariantId(tag);
      }).length;
      var cachedVariantCount = (sidebarHtmlCache[imgId].match(/data-variant-id="/g) || [])
        .length;
      var cachedSelectCount = (sidebarHtmlCache[imgId].match(/th-lookbook-product__variant/g) || [])
        .length;

      if (cachedReadyCount > cachedVariantCount + cachedSelectCount) {
        delete sidebarHtmlCache[imgId];
      } else {
        sidebar.innerHTML = sidebarHtmlCache[imgId];
        sidebar.classList.add('th-lookbook-products');
        sidebar.classList.remove('th-lookbook-products--loading', 'th-lookbook-products--legacy');
        sidebar.dataset.thBuilt = '1';
        qsa('.th-lookbook-product__cart', sidebar).forEach(function (btn) {
          setButtonIcon(btn, 'cart');
        });
        syncSidebarCartAvailability(sidebar, cachedTags);
        return qsa('.th-lookbook-product', sidebar).length > 0;
      }
    }

    var tags = getProductTags(modal);
    var hotspotTags = getHotspotTags(modal);
    if (!tags.length) return false;

    var ready = tagsHaveProducts(tags);
    if (!ready) return false;

    var html = '';

    tags.forEach(function (tag, index) {
      var panel = qs('.zooomy___show___tags', tag);
      if (!panel) return;

      var imgEl = qs('.zbodypimg img', panel);
      var titleEl = qs('.zooomytagptitle', panel);
      var priceEl = qs('.zooomytagprice span', panel) || qs('.zooomytagprice', panel);
      var linkEl = qs('.zbodypimg a, .zooomyseedetails', panel);

      if (!titleEl) return;

      var pos =
        parseTagPosition(tag) ||
        (hotspotTags[index] ? parseTagPosition(hotspotTags[index]) : null);
      var href = linkEl ? linkEl.getAttribute('href') : '#';
      var title = titleEl.textContent.trim();
      var priceHtml = priceEl ? priceEl.innerHTML : '';
      var handle = getProductHandleFromTag(tag, href) || '';
      var variantId = getVariantId(tag) || '';
      var variantHtml = buildVariantSelectHtml(qs('.zooomyshopvariant', panel), index);
      var posAttrs = pos
        ? ' data-tag-left="' + pos.left + '" data-tag-top="' + pos.top + '"'
        : '';

      html +=
        '<article class="th-lookbook-product" data-tag-index="' +
        index +
        '"' +
        (handle ? ' data-product-handle="' + handle + '"' : '') +
        (variantId ? ' data-variant-id="' + variantId + '"' : '') +
        posAttrs +
        '>' +
        '<a class="th-lookbook-product__thumb" href="' +
        href +
        '">' +
        (imgEl
          ? '<img src="' +
            imgEl.getAttribute('src') +
            '" alt="" loading="' +
            (index < 4 ? 'eager' : 'lazy') +
            '">'
          : '') +
        '</a>' +
        '<div class="th-lookbook-product__info">' +
        '<a class="th-lookbook-product__title" href="' +
        href +
        '">' +
        title +
        '</a>' +
        variantHtml +
        '<p class="th-lookbook-product__price">' +
        priceHtml +
        '</p>' +
        '</div>' +
        '<button type="button" class="th-lookbook-product__cart" aria-label="Kosárba"></button>' +
        '</article>';
    });

    if (!html) return false;

    if (prewarmOnly) {
      if (imgId) sidebarHtmlCache[imgId] = html;
      return true;
    }

    sidebar.innerHTML = html;
    sidebar.classList.add('th-lookbook-products');
    sidebar.classList.remove('th-lookbook-products--loading', 'th-lookbook-products--legacy');
    sidebar.dataset.thBuilt = '1';

    if (imgId) sidebarHtmlCache[imgId] = html;

    qsa('.th-lookbook-product__cart', sidebar).forEach(function (btn) {
      setButtonIcon(btn, 'cart');
    });

    syncSidebarCartAvailability(sidebar, tags);

    qsa('.th-lookbook-product__price', sidebar).forEach(function (el) {
      var spans = qsa('span', el);
      spans.forEach(function (span) {
        if (!span.classList.contains('zcomapreprice')) {
          span.textContent = formatPrice(span.textContent);
        }
      });
    });

    tags.forEach(function (tag, index) {
      var spot = qs('.zooomytagspot', tag);
      if (!spot || spot.dataset.thSpotBound === '1') return;
      spot.dataset.thSpotBound = '1';
      spot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var article = qs('.th-lookbook-product[data-tag-index="' + index + '"]', sidebar);
        if (!article) return;
        qsa('.th-lookbook-product', sidebar).forEach(function (el) {
          el.classList.remove('is-active');
        });
        article.classList.add('is-active');
        article.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });

    return qsa('.th-lookbook-product', sidebar).length > 0;
  }

  function countExpectedTags(modal) {
    var hotspotTags = getHotspotTags(modal);
    if (hotspotTags.length) return hotspotTags.length;
    return getProductTags(modal).length;
  }

  function countBuiltProducts(modal) {
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (!sidebar) return 0;
    return qsa('.th-lookbook-product', sidebar).length;
  }

  function ensureSidebarReady(modal, onReady) {
    bindSidebarDelegation(modal);

    var finished = false;
    var lastBuiltCount = 0;

    function finish() {
      if (finished) return;
      finished = true;
      if (typeof onReady === 'function') onReady();
    }

    var imgId = getModalImageId(modal);
    var tagsContainer = imgId ? document.getElementById('zooomyimage__tags-' + imgId) : null;
    var body = qs('.zooomygallerymodal-body', modal);
    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    var observer;
    var pollTimer;
    var pollCount = 0;
    var stableCount = 0;

    function cleanup() {
      if (observer) { observer.disconnect(); observer = null; }
      if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
    }

    function tryBuild() {
      if (tryLegacySidebar(modal)) {
        cleanup();
        finish();
        return true;
      }
      if (buildSidebar(modal)) {
        var built = countBuiltProducts(modal);
        if (!built) return false;

        var expected = countExpectedTags(modal);

        if (!finished) finish();

        if (built >= expected || expected === 0) {
          cleanup();
          return true;
        }

        if (built === lastBuiltCount) {
          stableCount += 1;
          if (stableCount >= 6) {
            cleanup();
            return true;
          }
        } else {
          stableCount = 0;
          lastBuiltCount = built;
          buildSidebar(modal);
        }
        return false;
      }
      return false;
    }

    if (tryBuild()) return;

    showSidebarLoading(modal);

    if (tagsContainer || body || sidebar) {
      observer = new MutationObserver(function () {
        tryBuild();
      });
      if (tagsContainer) {
        observer.observe(tagsContainer, { childList: true, subtree: true, characterData: true });
      }
      if (body) {
        observer.observe(body, { childList: true, subtree: true });
      }
      if (sidebar) {
        observer.observe(sidebar, { childList: true, subtree: true, characterData: true });
      }
    }

    pollTimer = setInterval(function () {
      pollCount += 1;
      if (tryBuild()) return;
      if (pollCount >= 60) {
        cleanup();
        if (!tryLegacySidebar(modal)) {
          enhanceLegacySidebar(modal);
        }
        finish();
      }
    }, 50);
  }

  function startHeaderGuard(modal) {
    ensureHeaderVisible();
    startHeaderGuardObserver();
    var count = 0;
    var timer = setInterval(function () {
      ensureHeaderVisible();
      count += 1;
      if (count >= 10) clearInterval(timer);
    }, 150);
    modal.dataset.thHeaderTimer = String(timer);
  }

  function afterSidebarReady(modal) {
    configureModalScroll(modal);
    resetModalShellStyles(modal);
    centerModal(modal);
    syncHotspots(modal);
    bindHotspotResize(modal);
  }

  function prepareModalForOpen(modal) {
    if (!modal) return;
    ensureModalPortal(modal);
    updateHeaderOffset();
    ensureHeaderVisible();
    startHeaderGuardObserver();
    prewarmImageRatio(modal);
    applyModalOrientation(modal, getImageRatio(modal));
  }

  function openModal(modal) {
    if (!modal) return;
    if (modal.dataset.thOpening === '1') return;
    modal.dataset.thOpening = '1';

    prepareModalForOpen(modal);
    resetSidebarForOpen(modal);
    applyModalOrientation(modal, getImageRatio(modal));
    lockPageScroll();

    qsa('.zooomygallerymodal').forEach(function (m) {
      if (m === modal) return;
      m.classList.remove('th-lookbook-modal--open', 'in');
      m.style.display = 'none';
    });

    modal.classList.add('th-lookbook-modal--open', 'in');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('zooomygallerymodal-open');

    centerModal(modal);
    bindCloseButton(modal);
    configureModalScroll(modal);
    bindSidebarDelegation(modal);
    primeModalImage(modal);
    preloadModalImage(modal);

    var sidebar = qs('.ZooomyImgCaptionsPopup', modal);
    if (sidebar) {
      sidebar.dataset.thBuilt = '';
    }

    startHeaderGuard(modal);

    ensureSidebarReady(modal, function () {
      delete modal.dataset.thOpening;
      afterSidebarReady(modal);
      ensureHeaderVisible();
    });
  }

  function removeBackdrop() {
    qsa('.zooomygallerymodal-backdrop').forEach(function (backdrop) {
      if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
    });
  }

  function closeModal(modal) {
    if (!modal) return;

    if (modal.dataset.thHeaderTimer) {
      clearInterval(Number(modal.dataset.thHeaderTimer));
      delete modal.dataset.thHeaderTimer;
    }

    stopHeaderGuardObserver();
    clearModalOrientation(modal);

    if (window.jQuery && window.jQuery.fn.zooomygallerymodal) {
      window.jQuery(modal).zooomygallerymodal('hide');
    } else {
      unlockPageScroll();
    }

    modal.classList.remove('th-lookbook-modal--open', 'in');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
    qsa('.th-lookbook-hotspot-layer', modal).forEach(function (layer) {
      layer.remove();
    });
    removeBackdrop();

    if (!qs('.zooomygallerymodal.in, .zooomygallerymodal.th-lookbook-modal--open')) {
      document.body.classList.remove('zooomygallerymodal-open');
    }
  }

  function bindCloseButton(modal) {
    mountCloseButton(modal);

    var closeBtn = qs('.zooomygallerybtn-close', modal);
    if (!closeBtn) return;

    if (closeBtn.dataset.thCloseBound === '1') return;
    closeBtn.dataset.thCloseBound = '1';

    closeBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeModal(modal);
      },
      true
    );
  }

  function bindModal(modal) {
    if (!modal || modal.dataset.thBound === '1') return;
    modal.dataset.thBound = '1';
    bindCloseButton(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(modal);
    });
  }

  function whenLookbookReady(cb) {
    var root = qs('[id^="ZooomyLookbook-"]');
    if (!root || root.children.length) {
      cb(root);
      return;
    }

    var readyObserver = new MutationObserver(function () {
      if (!root.children.length) return;
      readyObserver.disconnect();
      cb(root);
    });
    readyObserver.observe(root, { childList: true });
    window.setTimeout(function () {
      readyObserver.disconnect();
      cb(root);
    }, 10000);
  }

  function init() {
    protectHeaderFromZooomy();
    injectHotspotOverrides();
    cacheHeaderHeight();

    whenLookbookReady(function () {
      bindLookbookGridLayout();
      cacheGridImageRatios();
    });

    qsa('.zooomygallerymodal').forEach(function (modal) {
      bindModal(modal);
      bindSidebarDelegation(modal);
    });

    document.addEventListener(
      'mouseenter',
      function (e) {
        var trigger = e.target.closest('[data-toggle="zooomygallerymodal"]');
        if (!trigger || trigger.dataset.thPreloaded === '1') return;
        trigger.dataset.thPreloaded = '1';

        var modal = getModalFromTrigger(trigger);
        if (!modal) return;

        preloadModalImage(modal);
        buildSidebar(modal, true);
        applyModalOrientation(modal, getImageRatio(modal));
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest('[data-toggle="zooomygallerymodal"]');
        if (!trigger) return;

        var modal = getModalFromTrigger(trigger);
        if (!modal) return;

        bindModal(modal);
        prepareModalForOpen(modal);
        resetSidebarForOpen(modal);

        window.setTimeout(function () {
          if (
            modal.classList.contains('in') &&
            !modal.classList.contains('th-lookbook-modal--open')
          ) {
            openModal(modal);
          }
        }, 400);
      },
      true
    );

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.zooomygallerybtn-close');
      if (!closeBtn) return;
      var modal = closeBtn.closest('.zooomygallerymodal');
      if (!modal) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeModal(modal);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        qsa('.zooomygallerymodal.in, .zooomygallerymodal.th-lookbook-modal--open').forEach(closeModal);
      }
    });

    var mutationDebounce = null;
    var lookbookRoot = qs('[id^="ZooomyLookbook-"]');

    function onLookbookDomChange() {
      if (mutationDebounce) return;
      mutationDebounce = window.setTimeout(function () {
        mutationDebounce = null;
        qsa('.zooomygallerymodal').forEach(bindModal);
        bindLookbookGridImages(lookbookRoot || document);
        scheduleLookbookGridFix(lookbookRoot || document);
      }, 200);
    }

    if (lookbookRoot) {
      var lookbookObserver = new MutationObserver(onLookbookDomChange);
      lookbookObserver.observe(lookbookRoot, { childList: true, subtree: true });

      var bodyObserver = new MutationObserver(function (mutations) {
        var hasModal = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) return false;
            return (
              (node.classList && node.classList.contains('zooomygallerymodal')) ||
              (node.querySelector && node.querySelector('.zooomygallerymodal'))
            );
          });
        });
        if (hasModal) onLookbookDomChange();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: false });
    } else {
      var fallbackObserver = new MutationObserver(onLookbookDomChange);
      fallbackObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (window.jQuery) {
      window.jQuery(document).on('show.bs.zooomygallerymodal', function (e) {
        prepareModalForOpen(e.target);
        resetSidebarForOpen(e.target);
        applyModalOrientation(e.target, getImageRatio(e.target));
        lockPageScroll();
      });

      window.jQuery(document).on('shown.bs.zooomygallerymodal', function (e) {
        resetModalShellStyles(e.target);
        openModal(e.target);
        requestAnimationFrame(function () {
          resetModalShellStyles(e.target);
          centerModal(e.target);
        });
      });

      window.jQuery(document).on('hidden.bs.zooomygallerymodal', function (e) {
        var modal = e.target;
        if (modal && modal.dataset.thHeaderTimer) {
          clearInterval(Number(modal.dataset.thHeaderTimer));
          delete modal.dataset.thHeaderTimer;
        }
        if (modal) delete modal.dataset.thOpening;
        removeBackdrop();
        unlockPageScroll();
        document.body.classList.remove('zooomygallerymodal-open');
      });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
